// extracted by mini-css-extract-plugin
export default {"container":"ariseFeeTemplateForm_container__m2TTs","buttonWrapper":"ariseFeeTemplateForm_buttonWrapper__DwAZ8","line":"ariseFeeTemplateForm_line__eAvmk"};